import axios from 'axios';
import { useQuery, UseQueryOptions } from './useQuery';
import { useApp } from '../designs/paper/context/AppContext';
import { ReservableEventWithTimeslots } from '../../../../../shared/types/reservable';

type UseEventByIdOptions = UseQueryOptions<ReservableEventWithTimeslots, Error>;

/**
 * Hook to fetch a single event template with available timeslots
 * @param propertyId - The property ID
 * @param eventId - The event template ID
 * @param options - Additional react-query options
 */
export function useExperienceById(
  propertyId: string,
  eventId: string,
  options?: UseEventByIdOptions
) {
  const { config } = useApp();

  return useQuery<ReservableEventWithTimeslots, Error>(
    ['experienceDetails', propertyId, eventId],
    async () => {
      const response = await axios.get<ReservableEventWithTimeslots>(
        config.experienceDetailsUrl.replace(':eventId', eventId)
      );
      return response.data;
    },
    options
  );
}
